export type MeetingType = 'PRE_SALE' | 'CLIENT_WORK' | 'INTERNAL';

export const MEETING_TYPE_OPTIONS: ReadonlyArray<{ value: MeetingType; label: string }> = [
  { value: 'PRE_SALE', label: 'Пресейл' },
  { value: 'CLIENT_WORK', label: 'Работа с клиентом' },
  { value: 'INTERNAL', label: 'Внутренняя встреча' },
];

export function formatMeetingType(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return 'Не указан';
  }
  const found = MEETING_TYPE_OPTIONS.find((item) => item.value === value);
  return found?.label ?? 'Не указан';
}

export function formatClientLabel(
  meetingType: string | null | undefined,
  clientName: string | null | undefined,
): string {
  if (meetingType === 'INTERNAL') {
    return 'Внутренняя';
  }
  if (clientName === null || clientName === undefined || clientName.trim() === '') {
    return 'Не указаны';
  }
  return clientName;
}

export function formatParticipants(
  names: readonly string[] | null | undefined,
  emptyLabel = 'Не указаны',
): string {
  if (names === null || names === undefined || names.length === 0) {
    return emptyLabel;
  }
  if (names.length <= 3) {
    return names.join(', ');
  }
  const visible = names.slice(0, 2).join(', ');
  return `${visible} и ещё ${names.length - 2}`;
}

export function todayMeetingDate(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatMeetingDate(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  const match = /^(\d{4})-(\d{2})-(\d{2})$/u.exec(value);
  if (!match) {
    return value;
  }
  return `${match[3]}.${match[2]}.${match[1]}`;
}
